import React from "react"

import Button from "@components/ui/Button/Button"
import Icon from "@components/ui/Icon/Icon"
import useMediaQuery from "@components/hooks/useMediaQuery"
import { AppMediaQueries } from "@framework/constants/app"

export const SearchSubmitButton: React.FC<{
  autoFocus?: boolean
  disabled?: boolean
  loading?: boolean
  className?: string
  onStop?: () => void
}> = ({ autoFocus, disabled, loading, className, onStop }) => {
  const isMobile = useMediaQuery(AppMediaQueries.maxMobile)

  if (loading) {
    return (
      <Button
        size={isMobile ? "small" : "big"}
        color="primary"
        type="button"
        autoFocus={autoFocus}
        className={className}
        title="Stop"
        aria-label="Stop"
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          onStop?.()
        }}
      >
        <Icon name="checkbox-blank-fill" />
      </Button>
    )
  }

  return (
    <Button
      size={isMobile ? "small" : "big"}
      color="primary"
      type="submit"
      autoFocus={autoFocus}
      disabled={disabled}
      className={className}
      title="Submit"
      aria-label="Submit"
    >
      <Icon name="arrow-up" />
    </Button>
  )
}

export default SearchSubmitButton
